import { ERROR_FRAGMENT } from 'providers/graphql'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_WORKSPACE_BIDDER: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateWorkspaceBidder($input: UpdateWorkspaceBidderInput!) {
    updateWorkspaceBidder(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
